// data
const listTransaksiKonsumen = () => ({});
const listHistoryPaylinkKonsumen = () => ({})
const infoTransaksiKonsumen = () => ({});
const detailTransaksi = () => ({});

// filter
const pagination = () => ({
	limit: 20,
	offset: 0,
	length: 0,
	pageNumber: 0,
});
const search = () => ({
	key: "",
});
const queryListTransaksi = () => ({})

const state = {
	listTransaksiKonsumen: listTransaksiKonsumen(),
	listHistoryPaylinkKonsumen: listHistoryPaylinkKonsumen(),
	infoTransaksiKonsumen: infoTransaksiKonsumen(),
	detailTransaksi: detailTransaksi(),

	// filter
	pagination: pagination(),
	search: search(),
	isSearch: false,
	queryListTransaksi: queryListTransaksi(),

	scrollPosition: 0,
}

export {
	state as default,
	listTransaksiKonsumen,
	listHistoryPaylinkKonsumen,
	infoTransaksiKonsumen,
	detailTransaksi,
	pagination,
	search,
	queryListTransaksi,
}